import { render, staticRenderFns } from "./genderChart.vue?vue&type=template&id=661676b9"
import script from "./genderChart.vue?vue&type=script&lang=js"
export * from "./genderChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports